var exports = {
  "i": "x61f99309--f564f0--wrapper",
  "x": "x61f99309--f564f0--_with-after-icon",
};

module.exports = exports;
